const TYPE = '[PRODUCTS]'

export default {
    FETCH_START: `${TYPE} FETCH START`,
    FETCH_SUCCESS: `${TYPE} FETCH SUCCESS`,
    FETCH_ERROR: `${TYPE} FETCH ERROR`,
    TRANSLATE: `${TYPE} TRANSLATE`,
}